<template>
  <div style="width: 99%; height: 99%; padding: 2px; overflow: hidden">
    <el-container>
      <el-aside
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div
          class="Nodeoperation"
          style="padding-top: 10px; margin-bottom: 20px"
        >
          <el-button size="mini" type="primary" @click="openDialog"
            >上传JSON文件</el-button
          >
          <el-button type="warning" size="mini" @click="downWord"
            >下载word文档</el-button
          >
        </div>
        <el-dialog
          title="上传Json文件"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose"
          style="text-align: center"
        >
          <el-upload
            class="upload-demo"
            drag
            ref="upload"
            action="#"
            :headers="headerObj"
            :file-list="fileList"
            :on-change="handleChangeupload"
            :auto-upload="false"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传JSON文件，且不超过500kb
            </div>
          </el-upload>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="Uploadfile" :loading="dataLoad"
              >确 定</el-button
            >
          </span>
        </el-dialog>

        <!-- <div style="margin-top: 15px">
          <el-input
            placeholder="请输入内容"
            v-model="input3"
            class="input-with-select"
          >
            <el-select
              v-model="select"
              slot="prepend"
              placeholder="请选择"
              style="width: 90px"
            >
              <el-option label="节点" value="1"></el-option>
              <el-option label="关系" value="2"></el-option>
              <el-option label="属性" value="3"></el-option>
            </el-select>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchdata(input3, select)"
            ></el-button>
          </el-input>
        </div> -->
        <!-- 有搜索记录才出来 -->
        <!-- <div
          class="history"
          v-if="pastHistory"
          style="margin-top: 10px; margin-bottom: 30px"
        >
          <div class="hisText">历史记录</div>
          <div style="max-height: 80px; overflow: auto">
            <el-tag
              style="margin: 10px 10px 0 0; cursor: pointer"
              v-for="(item, index) in searchRefList"
              :key="index"
              @click="clickHistory(item, index)"
              closable
              @close="deleteHis(index)"
              :title="item"
              size="small"
            >
              {{ item }}
            </el-tag>
          </div>
        </div> -->
        <!-- <el-collapse v-model="activeNames" >
            <el-collapse-item title="具体属性" name="1"> -->
        <!-- <el-collapse class="search_box">
                <el-collapse-item>
                  <template slot="title">
                    一致性 Consistency<i class="header-icon el-icon-info"></i>
                  </template> -->

        <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              查询单个实体<i class="header-icon el-icon-info"></i>
            </template>
            <div class="limit_num">
              <span>展示的节点数量</span>
              <el-input
                size="mini"
                v-model="limit_num"
                class="node_num"
              ></el-input>
            </div>
            <div>
              <!-- <el-input
                placeholder="请选择节点"
                v-model="property_name"
                clearable
                :disabled="false"
                style="width: 200px"
              ></el-input> -->
                 <el-select v-model="property_name" clearable placeholder="请选择节点">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div style="margin-top: 10px">
              <el-input
                placeholder="请输入名称"
                v-model="input"
                class="input-with-select"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="queryEntity"
                  >查询实体</el-button
                >
              </el-input>
            </div>
          </el-collapse-item>
          <el-collapse-item title="查询知识图谱">
            <div class="limit_num">
              <span>展示的节点数量</span>
              <el-input
                size="mini"
                v-model="limit_num1"
                class="node_num"
              ></el-input>
            </div>
            <div>
              <!-- <el-input
                placeholder="请选择节点"
                v-model="property_name1"
                clearable
                :disabled="false"
                style="width: 200px"
              ></el-input> -->
                <el-select v-model="property_name1" clearable placeholder="请选择节点">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div style="margin-top: 10px">
              <el-input
                placeholder="请输入名称"
                v-model="input1"
                class="input-with-select"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="searchInformation"
                  >关系图谱</el-button
                >
              </el-input>
            </div>
          </el-collapse-item>
        </el-collapse>

        <div
          style="
            color: white;
            height: 40px;
            line-height: 40px;
            margin-top: 10px;
          "
        >
          <el-col :span="11">
            <el-input
              placeholder="可输入具体属性名称"
              v-model="parameters_label"
              autocomplete="off"
            ></el-input>
          </el-col>
          <el-col class="line" :span="2">：</el-col>
          <el-col :span="11">
            <el-input
              placeholder="可输入具体属性值"
              v-model="parameters_name"
              autocomplete="off"
            ></el-input>
          </el-col>
        </div>

        <h5 class="dYlKXO">节点__标签(*{{ listLabels.length }})</h5>
        <div class="style_meta__wrapper___1Njlk">
          <!-- <el-button type="success" size="mini" round style="margin-top:5px;margin-left:10px">(*{{listLabels.length}})</el-button> -->
          <el-button
            icon="el-icon-circle-plus"
            size="mini"
            @click="dialogVisible2 = true"
            style="margin-top: 5px; margin-right: 10px"
            >实体管理</el-button
          >
          <el-dialog
            title="实体管理"
            :visible.sync="dialogVisible2"
            width="30%"
            :before-close="handleClose"
          >
            <el-form
              :model="ruleForm"
              status-icon
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item
                label="实体类"
                prop="label"
                :rules="[{ required: true, message: '标签不能为空' }]"
              >
                <el-input
                  v-model="ruleForm.label"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="节点名称"
                prop="name"
                :rules="[{ required: true, message: '参数名称不能为空' }]"
              >
                <el-input v-model="ruleForm.name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item prop="inputValue">
                <el-collapse v-model="activeNames" @change="handleChange">
                  <el-collapse-item
                    title="具体属性"
                    name="1"
                    style="color: #333"
                  >
                    <el-form-item label="属性值" prop="properties_label">
                      <el-col :span="11">
                        <el-input
                          v-model="title_label"
                          autocomplete="off"
                        ></el-input>
                      </el-col>
                      <el-col class="line" :span="2">：</el-col>
                      <el-col :span="11">
                        <el-input
                          v-model="title_name"
                          autocomplete="off"
                        ></el-input>
                      </el-col>
                    </el-form-item>
                  </el-collapse-item>
                </el-collapse>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible2 = false" size="small"
                >取 消</el-button
              >
              <el-button
                type="primary"
                @click="addEntity('ruleForm')"
                size="small"
                >添加实体</el-button
              >
              <el-button
                type="danger"
                @click="deleteEntity('ruleForm')"
                size="small"
                >删除实体</el-button
              >
            </span>
          </el-dialog>
        </div>
        <div class="style_meta__wrapper___1Njlk1">
          <el-button
            class="first_button"
            type="warning"
            size="mini"
            style="margin-top: 5px"
            round
            v-for="item in listLabels"
            @click="AddProperties(item)"
            :key="item.id"
            >{{ item }}</el-button
          >
        </div>
        <h5 class="dYlKXO">关系__类型(*{{ listRelationships.length }})</h5>
        <div class="style_meta__wrapper___1Njlk">
          <!-- <el-button type="success" size="mini" round style="margin-top:5px;margin-left:10px">(*{{listRelationships.length}})</el-button> -->
          <el-button
            icon="el-icon-circle-plus"
            size="mini"
            @click="dialogVisible4 = true"
            style="margin-top: 5px; margin-right: 10px"
            >关系管理</el-button
          >
          <el-dialog
            title="关系管理"
            :visible.sync="dialogVisible4"
            width="30%"
            :before-close="handleClose"
          >
            <el-form
              :model="ruleForm3"
              status-icon
              ref="ruleForm3"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item
                label="头节点"
                prop="source_label"
                :rules="[{ required: true, message: '头节点不能为空' }]"
              >
                <el-input
                  v-model="ruleForm3.source_label"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="头节点名称"
                prop="source_name"
                :rules="[{ required: true, message: '头节点名称不能为空' }]"
              >
                <el-input
                  v-model="ruleForm3.source_name"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item prop="inputValue">
                <el-collapse v-model="activeNames2" @change="handleChange2">
                  <el-collapse-item
                    title="具体属性"
                    name="1"
                    style="color: #333"
                  >
                    <el-form-item label="属性值" prop="properties_label">
                      <el-col :span="11">
                        <el-input
                          v-model="title_label2"
                          autocomplete="off"
                        ></el-input>
                      </el-col>
                      <el-col class="line" :span="2">：</el-col>
                      <el-col :span="11">
                        <el-input
                          v-model="title_name2"
                          autocomplete="off"
                        ></el-input>
                      </el-col>
                    </el-form-item>
                  </el-collapse-item>
                </el-collapse>
              </el-form-item>
              <el-form-item label="关系名称" prop="relation">
                <el-input v-model="ruleForm3.relation"></el-input>
              </el-form-item>
              <el-form-item
                label="尾节点"
                prop="target_name"
                :rules="[{ required: true, message: '尾节点不能为空' }]"
              >
                <el-input
                  v-model="ruleForm3.target_name"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="尾节点名称"
                prop="target_value"
                :rules="[{ required: true, message: '尾节点名称不能为空' }]"
              >
                <el-input v-model="ruleForm3.target_value"></el-input>
              </el-form-item>
              <el-form-item prop="inputValue">
                <el-collapse v-model="activeNames3" @change="handleChange2">
                  <el-collapse-item
                    title="具体属性"
                    name="1"
                    style="color: #333"
                  >
                    <el-form-item label="属性值" prop="properties_label">
                      <el-col :span="11">
                        <el-input
                          v-model="title_label3"
                          autocomplete="off"
                        ></el-input>
                      </el-col>
                      <el-col class="line" :span="2">：</el-col>
                      <el-col :span="11">
                        <el-input
                          v-model="title_name3"
                          autocomplete="off"
                        ></el-input>
                      </el-col>
                    </el-form-item>
                  </el-collapse-item>
                </el-collapse>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible4 = false">取 消</el-button>
              <el-button type="primary" @click="addRelation('ruleForm3')"
                >添加关系</el-button
              >
              <el-button type="danger" @click="deleteRelation('ruleForm3')"
                >删除关系</el-button
              >
            </span>
          </el-dialog>
        </div>
        <div class="style_meta__wrapper___1Njlk1">
          <el-button
            class="first_button"
            type="success"
            size="mini"
            round
            v-for="item in listRelationships"
            :key="item.id"
            style="margin-top: 5px"
            >{{ item }}</el-button
          >
        </div>
        <h5 class="dYlKXO">属性__键(*{{ listProperties.length }})</h5>
        <div class="style_meta__wrapper___1Njlk">
          <!-- <el-button type="success" size="mini" round style="margin-top:5px;margin-left:10px" >(*{{listProperties.length}})</el-button> -->
          <el-button
            icon="el-icon-circle-plus"
            size="mini"
            @click="dialogVisible3 = true"
            style="margin-top: 5px; margin-right: 10px"
            >节点属性管理</el-button
          >
          <el-button
            v-text="btnText"
            @click="clickText"
            size="mini"
            style="margin-top: 5px"
          ></el-button>
          <el-dialog
            title="节点属性管理"
            :visible.sync="dialogVisible3"
            width="30%"
            :before-close="handleClose"
          >
            <el-form
              :model="ruleForm2"
              status-icon
              ref="ruleForm2"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item
                label="节点"
                prop="label"
                :rules="[{ required: true, message: '节点不能为空' }]"
              >
                <el-input
                  v-model="ruleForm2.label"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="节点名称"
                prop="name"
                :rules="[{ required: true, message: '节点名称不能为空' }]"
              >
                <el-input
                  v-model="ruleForm2.name"
                  autocomplete="off"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="属性值"
                prop="properties_label"
                :rules="[{ required: true, message: '具体属性不能为空' }]"
              >
                <el-col :span="11">
                  <el-input
                    v-model="ruleForm2.properties_label"
                    autocomplete="off"
                  ></el-input>
                </el-col>
                <el-col class="line" :span="2">：</el-col>
                <el-col :span="11">
                  <el-input
                    v-model="ruleForm2.properties_name"
                    autocomplete="off"
                  ></el-input>
                </el-col>
              </el-form-item>
              <el-form-item>
                <i class="el-icon-plus" @click="showfrom"></i>
              </el-form-item>
              <el-form-item label="属性值" v-if="attribute">
                <el-col :span="11">
                  <el-input
                    v-model="ruleForm2.properties_label2"
                    autocomplete="off"
                  ></el-input>
                </el-col>
                <el-col class="line" :span="2">：</el-col>
                <el-col :span="11">
                  <el-input
                    v-model="ruleForm2.properties_name2"
                    autocomplete="off"
                  ></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="属性值" v-if="attribute2">
                <el-col :span="11">
                  <el-input
                    v-model="ruleForm2.properties_label3"
                    autocomplete="off"
                  ></el-input>
                </el-col>
                <el-col class="line" :span="2">：</el-col>
                <el-col :span="11">
                  <el-input
                    v-model="ruleForm2.properties_name3"
                    autocomplete="off"
                  ></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="属性值" v-if="attribute3">
                <el-col :span="11">
                  <el-input
                    v-model="ruleForm2.properties_label4"
                    autocomplete="off"
                  ></el-input>
                </el-col>
                <el-col class="line" :span="2">：</el-col>
                <el-col :span="11">
                  <el-input
                    v-model="ruleForm2.properties_name4"
                    autocomplete="off"
                  ></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="属性值" v-if="attribute4">
                <el-col :span="11">
                  <el-input
                    v-model="ruleForm2.properties_label5"
                    autocomplete="off"
                  ></el-input>
                </el-col>
                <el-col class="line" :span="2">：</el-col>
                <el-col :span="11">
                  <el-input
                    v-model="ruleForm2.properties_name5"
                    autocomplete="off"
                  ></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="属性值" v-if="attribute5">
                <el-col :span="11">
                  <el-input
                    v-model="ruleForm2.properties_label6"
                    autocomplete="off"
                  ></el-input>
                </el-col>
                <el-col class="line" :span="2">：</el-col>
                <el-col :span="11">
                  <el-input
                    v-model="ruleForm2.properties_name6"
                    autocomplete="off"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible3 = false">取 消</el-button>
              <el-button type="primary" @click="addProperties('ruleForm2')"
                >添加</el-button
              >
            </span>
          </el-dialog>
        </div>
        <div class="style_meta__wrapper___1Njlk1">
          <el-button
            size="mini"
            type="info"
            class="first_button"
            round
            v-for="item in listProperties.slice(0, this.limitN)"
            :key="item.id"
            style="margin-top: 5px"
            >{{ item }}</el-button
          >
        </div>
        <el-button
          style="margin-left: 10px"
          type="danger"
          size="mini"
          @click="deleteNode"
          :loading="loadData"
          i
          class="el-icon-delete"
        ></el-button>
        <el-button type="primary" size="mini" @click="downJSON"
          >下载知识图谱的JSON数据</el-button
        >
      </el-aside>
      <el-main>
        <div id="container"></div>
        <div id="listInformation" v-show="informationflag" v-drag>
          <h1 style="text-align: center">
            节点简述<span
              style="float: right; cursor: pointer"
              @click="informationflag = false"
              >X</span
            >
          </h1>
          <div
            v-for="(item, index) in selectedUserInfo"
            :key="index"
            class="pre"
          >
            <span style="color: red">{{ index }} :</span>
            <img
              class="images"
              v-if="index == '图片'"
              width="80%"
              height="20%"
              :src="item"
            />
            <span v-else> {{ item }}</span>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script src="../../../public/js/downJson.js"></script>
<script>
import G6 from "@antv/g6";
import api from "@/services/python";
import { uniqBy, unionWith } from "lodash";
import "@/utils/directive.js";
export default {
  data() {
    return {
      headerObj: {
        Authorization: window.sessionStorage.getItem("token"),
      },
      attribute: false,
      attribute2: false,
      attribute3: false,
      attribute4: false,
      attribute5: false,
      limit_num: 50,
      limit_num1: 50,
      title_label: "",
      title_name: "",
      title_label2: "",
      title_name2: "",
      title_label3: "",
      title_name3: "",
      activeNames: [],
      activeNames2: [],
      activeNames3: [],
      parameters_label: "", // 搜索知识图谱
      parameters_name: "", // 搜索知识图谱
      dynamicTags: [],
      inputVisible: false,
      pastHistory: true, //搜索记录
      searchRefList: [],
      loadData: false,
      loading: true,
      informationflag: false,
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      fileList: [],
      input3: "",
      select: "",
      dataLoad: false,
      property_name: "",
      property_name1: "",
      input: "",
      input1: "",
      listLabels: [], // 列出所以标签
      limitN: 30,
      btnText: "显示全部",
      listRelationships: [], //列出所有关系
      listProperties: [], //列出所有属性
      G6data: {
        nodes: [],
        edges: [],
      },
      graph: "",
      NodeTail: "",
      selectedUserInfo: [], // 节点信息
      ruleForm: {
        label: "",
        name: "",
        inputValue: "",
      },
      ruleForm2: {
        label: "",
        name: "",
        properties_label: "",
        properties_name: "",
        properties_label2: "",
        properties_name2: "",
        properties_label3: "",
        properties_name3: "",
        properties_label4: "",
        properties_name4: "",
        properties_label5: "",
        properties_name5: "",
        properties_label6: "",
        properties_name6: "",
      },
      ruleForm3: {
        source_label: "",
        source_name: "",
        source_value: "",
        target_label: "",
        target_name: "",
        target_value: "",
        relation: "",
      },
      nodesInforList: [],
      options: [{
          value: '研发单位',
          label: '研发单位'
        }, {
          value: '类型',
          label: '类型'
        }, {
          value: '基地',
          label: '基地'
        }, {
          value: '武器装备',
          label: '武器装备'
        }, {
          value: '大类',
          label: '大类'
        }, {
          value: '学校',
          label: '学校'
        }, {
          value: '产国',
          label: '产国'
        }, {
          value: '制造商',
          label: '制造商'
        }, {
          value: '地区',
          label: '地区'
        }],
      // baseApi:api.knowledge_graph.empty,
    };
  },
  // computed:{
  //   newlistLabels:()=>{
  //      return
  //   }
  // },
  watch: {
    // 如果input框为空值就返回所有
    input3(value) {
      if (!value) {
        if (this.select === "1") {
          this.listLabels = this.$store.state.labelsList;
        } else if (this.select === "2") {
          this.listRelationships = this.$store.state.relationList;
        } else if (this.select === "3") {
          this.listProperties = this.$store.state.propertyList;
        }
      }
    },
  },
  methods: {
    // 初始化知识图谱
    initialization() {},
    // 下载json数据
    downJSON() {
      const params = {
        file_type: 1,
      };
      api.knowledge_graph
        .export({}, { params })
        .response.then((res) => res.data)
        .then((res) => {
          var content = JSON.stringify({
            jiedao: res,
          });

          var blob = new Blob([content], {
            type: "text/plain;charset=utf-8",
          });
          console.log(blob);
          saveAs(blob, "AssociationAnalysis.json");
        });
    },
    // 下载word文档
    downWord() {
      window.open("/基地列表.docx");
    },
    closeattribute() {
      this.attribute = false;
      this.attribute2 = false;
      this.attribute3 = false;
      this.attribute4 = false;
      this.attribute5 = false;
    },
    showfrom() {
      if (
        this.attribute === false &&
        this.attribute2 === false &&
        this.attribute3 === false &&
        this.attribute4 === false &&
        this.attribute5 === false
      ) {
        this.attribute = true;
      } else if (
        this.attribute === true &&
        this.attribute2 === false &&
        this.attribute3 === false &&
        this.attribute4 === false &&
        this.attribute5 === false
      ) {
        this.attribute2 = true;
      } else if (
        this.attribute === true &&
        this.attribute2 === true &&
        this.attribute3 === false &&
        this.attribute4 === false &&
        this.attribute5 === false
      ) {
        this.attribute3 = true;
      } else if (
        this.attribute === true &&
        this.attribute2 === true &&
        this.attribute3 === true &&
        this.attribute4 === false &&
        this.attribute5 === false
      ) {
        this.attribute4 = true;
      } else if (
        this.attribute === true &&
        this.attribute2 === true &&
        this.attribute3 === true &&
        this.attribute4 === true &&
        this.attribute5 === false
      ) {
        this.attribute5 = true;
      }
    },
    handleChange(val) {
      console.log(val);
    },
    handleChange2(val) {
      console.log(val);
    },
    // 去重方法封装
    unique(arr) {
      return arr.filter(function (item, index, arr) {
        return arr.indexOf(item, 0) === index;
      });
    },
    // 排序
    saveHistory(data) {
      if (this.searchRefList !== null) {
        this.searchRefList.unshift(data);
      } else {
        this.searchRefList = [];
        this.searchRefList.push(data);
      }

      this.searchRefList = this.unique(this.searchRefList);

      if (this.searchRefList.length > 10) {
        //最多保存10条
        this.searchRefList = this.searchRefList.slice(0, 10);
      }
      localStorage.setItem("labelsList", JSON.stringify(this.searchRefList)); //存localStorage
      this.pastHistory = true;
    },
    // 点击历史记录返回给input框
    clickHistory(data) {
      this.input3 = data;
    },
    //点击删除记录
    deleteHis(index) {
      if (isNaN(index) || index >= this.searchRefList.length) {
        return false;
      }
      this.searchRefList.splice(index, 1);

      localStorage.setItem("labelsList", JSON.stringify(this.searchRefList)); //保存删除后的新数组
      if (this.searchRefList.length === 0) {
        this.pastHistory = false;
      }
    },
    // 搜索
    searchdata(inputV, selectV) {
      if (!selectV || !inputV) {
        this.$message.warning("请将搜索信息填写完整");
        return;
      }
      // 1是节点_标签
      if (selectV === "1") {
        this.listLabels = this.listLabels.filter((item) => {
          // console.log(item.name, item.name.includes(this.input));
          if (item.includes(inputV) == true) {
            console.log("节点", item);
            return item;
          }
        });
        // 2是关系_类型
      } else if (selectV === "2") {
        this.listRelationships = this.listRelationships.filter((item) => {
          // console.log(this.listRelationships);
          if (item.includes(inputV)) {
            console.log("关系", item);
            return item;
          }
        });
        // 3是属性
      } else if (selectV === "3") {
        this.listProperties = this.listProperties.filter((item) => {
          // console.log(item.name, item.name.includes(this.input));
          if (item.includes(inputV)) {
            console.log("属性", item);
            return item;
          }
        });
      }
      this.saveHistory(inputV);
    },
    // 创建实体
    addEntity(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.title_label || !this.title_name) {
            var params = {
              label: this.ruleForm.label + "",
              名称: this.ruleForm.name + "",
            };
          } else {
            var params = {
              label: this.ruleForm.label + "",
              名称: this.ruleForm.name + "",
              parameters:
                "{" +
                this.title_label +
                ":" +
                "'" +
                this.title_name +
                "'" +
                "}",
            };
          }

          api.knowledge_graph
            .entity(params)
            .response.then((res) => res.data)
            .then((res) => {
              if (res.code == 200) {
                this.$message.warning(res.data.msg);
                this.handleClose();
                this.getData();
                this.ruleForm = {};
                this.title_label = "";
                this.title_name = "";
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除实体
    deleteEntity(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.title_label || !this.title_name) {
            var params = {
              label: this.ruleForm.label + "",
              名称: this.ruleForm.name + "",
            };
          } else {
            var params = {
              label: this.ruleForm.label + "",
              名称: this.ruleForm.name + "",
              parameters:
                "{" +
                this.title_label +
                ":" +
                "'" +
                this.title_name +
                "'" +
                "}",
            };
          }
          api.knowledge_graph
            .deletentity(params)
            .response.then((res) => res.data)
            .then((res) => {
              if (res.code == 200) {
                this.$message.warning(res.data.msg);
                this.handleClose();
                this.getData();
                this.ruleForm = {};
                this.title_label = "";
                this.title_name = "";
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 创建关系
    addRelation(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.ruleForm3.relation) {
            this.$message.warning("关系名称不能为空");
            return;
          }

          if (
            !this.title_label2 ||
            !this.title_name2 ||
            !this.title_label3 ||
            !this.title_name3
          ) {
            // 不传具体参数
            var param = {
              source_node: {
                label: this.ruleForm3.source_label + "",
                名称: this.ruleForm3.source_name + "",
              },
              target_node: {
                label: this.ruleForm3.target_name + "",
                名称: this.ruleForm3.target_value + "",
              },
            };
            // 传具体参数
          } else {
            var param = {
              source_node: {
                label: this.ruleForm3.source_label + "",
                名称: this.ruleForm3.source_name + "",
                parameters:
                  "{" +
                  this.title_label2 +
                  ":" +
                  "'" +
                  this.title_name2 +
                  "'" +
                  "}",
              },
              target_node: {
                label: this.ruleForm3.target_name + "",
                名称: this.ruleForm3.target_value + "",
                parameters:
                  "{" +
                  this.title_label3 +
                  ":" +
                  "'" +
                  this.title_name3 +
                  "'" +
                  "}",
              },
            };
          }
          var params = {
            relation: this.ruleForm3.relation + "",
          };
          api.knowledge_graph
            .relation(param, { params })
            .response.then((res) => res.data)
            .then((res) => {
              if (res.code == 200 && res.data != null) {
                this.$message.info(res.data.msg);
                this.handleClose();
                this.getData();
                this.ruleForm3 = {};
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除关系
    deleteRelation(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const param = {
            "relation ": this.ruleForm3.relation + "",
          };
          if (
            !this.title_label2 ||
            !this.title_name2 ||
            !this.title_label3 ||
            !this.title_name3
          ) {
            // 不传具体参数
            var params = {
              node1: {
                label: this.ruleForm3.source_label + "",
                名称: this.ruleForm3.source_name + "",
              },
              node2: {
                label: this.ruleForm3.target_name + "",
                名称: this.ruleForm3.target_value + "",
              },
            };
            // 传具体参数
          } else {
            var params = {
              node1: {
                label: this.ruleForm3.source_label + "",
                名称: this.ruleForm3.source_name + "",
                parameters:
                  "{" +
                  this.title_label2 +
                  ":" +
                  "'" +
                  this.title_name2 +
                  "'" +
                  "}",
              },
              node2: {
                label: this.ruleForm3.target_name + "",
                名称: this.ruleForm3.target_value + "",
                parameters:
                  "{" +
                  this.title_label3 +
                  ":" +
                  "'" +
                  this.title_name3 +
                  "'" +
                  "}",
              },
            };
          }

          api.knowledge_graph
            .deleterelation(params, { param })
            .response.then((res) => res.data)
            .then((res) => {
              if (res.code == 200 && res.data != null) {
                this.$message.info(res.data.msg);
                this.handleClose();
                this.getData();
                this.ruleForm3 = {};
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 设置节点新属性
    addProperties(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            !this.ruleForm2.properties_label2 &&
            !this.ruleForm2.properties_name2 &&
            !this.ruleForm2.properties_label3 &&
            !this.ruleForm2.properties_name3 &&
            !this.ruleForm2.properties_label4 &&
            !this.ruleForm2.properties_name4 &&
            !this.ruleForm2.properties_label5 &&
            !this.ruleForm2.properties_name5 &&
            !this.ruleForm2.properties_label6 &&
            !this.ruleForm2.properties_name6
          ) {
            var params = {
              label: this.ruleForm2.label + "",
              名称: this.ruleForm2.name + "",
              properties: {
                [this.ruleForm2.properties_label]:
                  this.ruleForm2.properties_name + "",
              },
            };
          } else if (
            this.ruleForm2.properties_label2 &&
            this.ruleForm2.properties_name2 &&
            !this.ruleForm2.properties_label3 &&
            !this.ruleForm2.properties_name3 &&
            !this.ruleForm2.properties_label4 &&
            !this.ruleForm2.properties_name4 &&
            !this.ruleForm2.properties_label5 &&
            !this.ruleForm2.properties_name5 &&
            !this.ruleForm2.properties_label6 &&
            !this.ruleForm2.properties_name6
          ) {
            var params = {
              label: this.ruleForm2.label + "",
              名称: this.ruleForm2.name + "",
              properties: {
                [this.ruleForm2.properties_label]:
                  this.ruleForm2.properties_name + "",
                [this.ruleForm2.properties_label2]:
                  this.ruleForm2.properties_name2 + "",
              },
            };
          } else if (
            this.ruleForm2.properties_label2 &&
            this.ruleForm2.properties_name2 &&
            this.ruleForm2.properties_label3 &&
            this.ruleForm2.properties_name3 &&
            !this.ruleForm2.properties_label4 &&
            !this.ruleForm2.properties_name4 &&
            !this.ruleForm2.properties_label5 &&
            !this.ruleForm2.properties_name5 &&
            !this.ruleForm2.properties_label6 &&
            !this.ruleForm2.properties_name6
          ) {
            var params = {
              label: this.ruleForm2.label + "",
              名称: this.ruleForm2.name + "",
              properties: {
                [this.ruleForm2.properties_label]:
                  this.ruleForm2.properties_name + "",
                [this.ruleForm2.properties_label2]:
                  this.ruleForm2.properties_name2 + "",
                [this.ruleForm2.properties_label3]:
                  this.ruleForm2.properties_name3 + "",
              },
            };
          } else if (
            this.ruleForm2.properties_label2 &&
            this.ruleForm2.properties_name2 &&
            this.ruleForm2.properties_label3 &&
            this.ruleForm2.properties_name3 &&
            this.ruleForm2.properties_label4 &&
            this.ruleForm2.properties_name4 &&
            !this.ruleForm2.properties_label5 &&
            !this.ruleForm2.properties_name5 &&
            !this.ruleForm2.properties_label6 &&
            !this.ruleForm2.properties_name6
          ) {
            var params = {
              label: this.ruleForm2.label + "",
              名称: this.ruleForm2.name + "",
              properties: {
                [this.ruleForm2.properties_label]:
                  this.ruleForm2.properties_name + "",
                [this.ruleForm2.properties_label2]:
                  this.ruleForm2.properties_name2 + "",
                [this.ruleForm2.properties_label3]:
                  this.ruleForm2.properties_name3 + "",
                [this.ruleForm2.properties_label4]:
                  this.ruleForm2.properties_name4 + "",
              },
            };
          } else if (
            this.ruleForm2.properties_label2 &&
            this.ruleForm2.properties_name2 &&
            this.ruleForm2.properties_label3 &&
            this.ruleForm2.properties_name3 &&
            this.ruleForm2.properties_label4 &&
            this.ruleForm2.properties_name4 &&
            this.ruleForm2.properties_label5 &&
            this.ruleForm2.properties_name5 &&
            !this.ruleForm2.properties_label6 &&
            !this.ruleForm2.properties_name6
          ) {
            var params = {
              label: this.ruleForm2.label + "",
              名称: this.ruleForm2.name + "",
              properties: {
                [this.ruleForm2.properties_label]:
                  this.ruleForm2.properties_name + "",
                [this.ruleForm2.properties_label2]:
                  this.ruleForm2.properties_name2 + "",
                [this.ruleForm2.properties_label3]:
                  this.ruleForm2.properties_name3 + "",
                [this.ruleForm2.properties_label4]:
                  this.ruleForm2.properties_name4 + "",
                [this.ruleForm2.properties_label5]:
                  this.ruleForm2.properties_name5 + "",
              },
            };
          } else if (
            this.ruleForm2.properties_label2 &&
            this.ruleForm2.properties_name2 &&
            this.ruleForm2.properties_label3 &&
            this.ruleForm2.properties_name3 &&
            this.ruleForm2.properties_label4 &&
            this.ruleForm2.properties_name4 &&
            this.ruleForm2.properties_label5 &&
            this.ruleForm2.properties_name5 &&
            this.ruleForm2.properties_label6 &&
            this.ruleForm2.properties_name6
          ) {
            var params = {
              label: this.ruleForm2.label + "",
              名称: this.ruleForm2.name + "",
              properties: {
                [this.ruleForm2.properties_label]:
                  this.ruleForm2.properties_name + "",
                [this.ruleForm2.properties_label2]:
                  this.ruleForm2.properties_name2 + "",
                [this.ruleForm2.properties_label3]:
                  this.ruleForm2.properties_name3 + "",
                [this.ruleForm2.properties_label4]:
                  this.ruleForm2.properties_name4 + "",
                [this.ruleForm2.properties_label5]:
                  this.ruleForm2.properties_name5 + "",
                [this.ruleForm2.properties_label6]:
                  this.ruleForm2.properties_name6 + "",
              },
            };
          }
          api.knowledge_graph
            .properties(params)
            .response.then((res) => res.data)
            .then((res) => {
              if (res.code == 200 && res.data != null) {
                this.$message.success(res.data.msg);
                this.handleClose();
                this.getData();
                this.ruleForm2 = {};
                this.closeattribute();
              } else {
                this.$message.error(res.data.msg);
                this.handleClose();
                this.ruleForm2 = {};
                this.closeattribute();
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 确定上传
    Uploadfile() {
      let fd = new FormData();
      // fd.append("name",this.name);
      this.fileList.forEach((item) => {
        //文件信息中raw才是真的文件
        fd.append("file", item.raw);
        console.log(item.raw);
      });

      api.knowledge_graph
        .upload(fd)
        .response.then((res) => res.data)
        .then((res) => {
          console.log("{" + res + "}");
          if (res.includes("end")) {
            this.$message({
              message: "上传结束",
              type: "success",
            });
            this.dataLoad = true;
          } else {
            this.$message.error("上传失败");
            this.dataLoad = true;
          }
          this.dialogVisible = false;
          this.getData();
        });
    },
    handleChangeupload(file, fileList) {
      this.fileList = fileList;
      console.log(file, fileList);
    },
    openDialog() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogVisible2 = false;
      this.dialogVisible3 = false;
      this.dialogVisible4 = false;
    },
    // 删除数据
    deleteNode() {
      this.$confirm("此操作将永久删除文件数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await api.knowledge_graph
            .empty()
            .response.then((res) => res.data);
          if (res.code == 200) {
            this.loadData = true;
            this.$message("数据删除成功");
            this.getData();
            this.loadData = false;
          } else {
            this.$message.error("数据删除失败");
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changeKey(arr, key) {
      let newArr = [];
      arr.forEach((item, index) => {
        let newObj = {};
        for (var i = 0; i < key.length; i++) {
          newObj[key[i]] = item[Object.keys(item)[i]];
        }
        newArr.push(newObj);
      });
      console.log(newArr);
      return newArr;
    },
    // 查询实体
    async queryEntity() {
      if (this.property_name === "" || this.input == "") {
        this.$message({
          message: "请将信息填写完整",
          type: "warning",
        });
        return;
      }
      if (!this.parameters_label || !this.parameters_name) {
        var param = {
          label: this.property_name + "",
          名称: this.input + "",
        };
      } else {
        var param = {
          label: this.property_name + "",
          名称: this.input + "",
          properties: {
            [this.parameters_label]: this.parameters_name + "",
          },
        };
      }
      const params = {
        limit: this.limit_num,
      };
      const res = await api.knowledge_graph
        .query_entities(param, { params })
        .response.then((res) => res.data);
      if (res.code == 200) {
        if (!res.data) {
          this.$message.info("暂无该节点信息");
          return;
        }
        const nodes = res.data[0]?.nodes;
        // .map((item) => this.superLongTextHandle(item.label, 60, 12))
        nodes.forEach((item) => {
          item.label = this.superLongTextHandle(item.label, 60, 12);
        });

        this.G6data.nodes = nodes || [];
        this.G6data.edges = res.data[0].edges;
        this.graph.data(this.G6data);
        this.graph.render();
        console.log("G6", this.G6data);
      }
    },
    isChinese(name) {
      let filter = /[\u4E00-\u9FA5\uF900-\uFA2D]{1,}/;
      if (filter.test(name)) {
        return true;
      }
      return false;
    },
    // 关系图谱
    async searchInformation() {
      if (this.property_name1 === "" || this.input1 == "") {
        this.$message({
          message: "请将信息填写完整",
          type: "warning",
        });
        return;
      }
      if (!this.parameters_label || !this.parameters_name) {
        var param = {
          label: this.property_name1 + "",
          名称: this.input1 + "",
        };
      } else {
        var param = {
          label: this.property_name1 + "",
          名称: this.input1 + "",
          properties: {
            [this.parameters_label]: this.parameters_name + "",
          },
        };
      }
      const params = {
        limit: this.limit_num1,
      };
      const res = await api.knowledge_graph
        .query_relationship(param, { params })
        .response.then((res) => res.data);
      if (res.code == 200) {
        if (!res.data) {
          this.$message.info("暂无该节点信息");
          return;
        }
        const nodes = res.data[0]?.nodes;
        // .map((item) => this.superLongTextHandle(item.label, 60, 12))
        nodes.forEach((item) => {
          item.label = this.superLongTextHandle(item.label, 60, 12);
        });
        console.log(nodes, "nodes");

        this.G6data.nodes = nodes || [];

        const edges = res.data[0]?.edges;
        console.log("listData=====>", edges);
        // 更换后端key值

        let kayMap = { label: "edgeLabel" };
        const setEmpty = (data, keyMap) => {
          let objs = Object.keys(data).reduce((newData, key) => {
            let newKey = keyMap[key] || key;
            newData[newKey] = data[key];
            return newData;
          }, {});
          return objs;
        };
        let arr = edges.map((item) => {
          return setEmpty(item, kayMap);
        });
        console.log("arr=====>", arr);
        this.G6data.edges = arr;

        // this.G6data.edges = res.data[0].edges

        //  let brr= changeKey (res.data[0].nodes, ['userName', 'age']);
        // res.data[0].nodes.forEach((item) =>{
        //   let obj = {}
        //   obj.id = item.名称
        //   obj.neo4jImportId = item.neo4jImportId
        //   obj.label = item.名称
        //   obj.服役时间 = item.服役时间
        //   obj.发动机数量 = item.发动机数量
        //   obj.图片 = item.图片
        //   obj.简介 = item.简介

        // })
        // for (var i = 0; i < nodes.length; i++) {
        //   this.G6data.nodes.push[
        //     id:nodes[i].neo4jImportId
        //   ]
        // }

        this.graph.data(this.G6data);
        this.graph.render();
        console.log("G6", this.G6data);
      }
    },
    // 添加properties属性
    AddProperties(item) {
      this.property_name = item;
      this.property_name1 = item;

      const params = {
        label: item + "",
        limit: 25,
      };
      api.knowledge_graph
        .list_all({}, { params })
        .response.then((res) => res.data)
        .then((res) => {
          if (!res.data) {
            this.$message.info("暂无该节点信息");
            return;
          }
          const nodes = res.data[0]?.nodes;
          nodes.forEach((item) => {
            item.label = this.superLongTextHandle(item.label, 60, 12);
          });
          console.log(nodes, "nodes");

          this.G6data.nodes = nodes || [];

          const edges = res.data[0]?.edges;
          this.G6data.edges = edges;
          this.graph.data(this.G6data);
          this.graph.render();
          console.log("G6", this.G6data);
        });
    },
     getData() {
      this.initialization();
      const params = {
        domain: "军事情报",
      };
      api.knowledge_graph.init(null, { params }).response.then((res) => res.data)
        .then((res) => {
          if(res.code == 200) {
        api.knowledge_graph.list_labels().response.then((res) => res.data).then((res) => {
          if (res.code == 200) {
            this.listLabels = res.data[0].labels;
            this.$store.commit("setlabelsList", res.data[0].labels);
          }
        });
        api.knowledge_graph.list_relationships().response.then((res) => res.data).then((res) => {
          if (res.code == 200) {
            this.listRelationships = res.data[0].relationships;
            this.$store.commit("setrelationList", res.data[0].relationships);
            // console.log('this.listRelationships',this.listRelationships);
          }
        });
        api.knowledge_graph.list_properties().response.then((res) => res.data).then((res) => {
          if (res.code == 200) {
            this.loading = false;
            this.dataLoad = false;
            this.listProperties = res.data[0].properties;
            this.$store.commit("setpropertyList", res.data[0].properties);
            // console.log('this.listProperties',this.listProperties);
          }
        });
          }
        });
      
    },
    clickText() {
      if (this.btnText == "显示全部") {
        this.btnText = "隐藏部分";
        this.limitN = this.listProperties.length;
      } else if (this.btnText == "隐藏部分") {
        this.btnText = "显示全部";
        this.limitN = "30";
      }
    },
    EditEdge(item) {
      this.graph.update(item, {
        label: this.NodeTail,
      });
    },
    delateEdge(item) {
      this.graph.update(item, {
        label: "",
      });
    },
    superLongTextHandle(str, maxWidth, fontSize) {
      let currentWidth = 0;
      let res = str;
      // 区分汉字和字母
      const pattern = new RegExp("[\u4E00-\u9FA5]+");
      str.split("").forEach((letter, i) => {
        if (currentWidth > maxWidth) return;
        if (pattern.test(letter)) {
          // 中文字符
          currentWidth += fontSize;
        } else {
          // 根据字体大小获取单个字母的宽度
          currentWidth += G6.Util.getLetterWidth(letter, fontSize);
        }
        if (currentWidth > maxWidth) {
          res = `${str.substr(0, i)}\n${this.superLongTextHandle(
            str.substr(i),
            maxWidth,
            fontSize
          )}`;
        }
      });
      return res;
    },
    initGraph() {
      const container = document.getElementById("container");
      const width = container.scrollWidth;
      const height = container.scrollHeight || 500;
      this.graph = new G6.Graph({
        container: "container",
        width,
        height,
        modes: {
          default: ["drag-canvas", "drag-node", "zoom-canvas"],
          altSelect: [
            {
              type: "click-select",
              trigger: "alt",
            },
            "drag-node",
          ],
        },

        layout: {
          type: "force",
          preventOverlap: true,
          nodeStrength: -1000,
          minMobement: 0.1,
          unitRadius: 200,
          linkDistance: 150,
          center: [500, 300],
        },
        defaultNode: {
          labelCfg: {
            style: {
              fill: "#f1f8f2",
              fontSize: 10,
            },
          },
          style: {
            fill: "#938d92",
            stroke: "white",
          },
          size: 60,
        },
        defaultEdge: {
          size: 3,
          style: {
            fill: "#f1f8f2",
            stroke: "skyblue",
            endArrow: true,
          },
          labelCfg: {
            autoRotate: true,
            refY: 10,
            style: {
              stroke: "#f1f8f2",
              fill: "#f1f8f2",
            },
          },
        },
        animate: true,
      });

      this.graph.node((node) => {
        if (node.class === "产国") {
          return {
            style: {
              fill: "#2db7f5",
              stroke: "#ea7171",
            },
          };
        } else if (node.class === "武器装备") {
          return {
            style: {
              fill: "#B77627",
              stroke: "#27B7B2",
            },
          };
        } else if (node.class === "研发单位") {
          return {
            style: {
              fill: "#7427B7",
              stroke: "#2EB727",
            },
          };
        } else if (node.class === "制造商") {
          return {
            style: {
              fill: "#F52C04",
              stroke: "#2db7f5",
            },
          };
        } else if (node.class === "地区") {
          return {
            style: {
              fill: "#30B06E",
              stroke: "#B77627",
            },
          };
        } else if (node.class === "基地") {
          return {
            style: {
              fill: "#30B0AC",
              stroke: "#7427B7",
            },
          };
        } else if (node.class === "大类") {
          return {
            style: {
              fill: "#B03094",
              stroke: "#161718",
            },
          };
        }
        return {
          style: {
            fill: "#938d92",
            stroke: "white",
          },
        };
      });

      if (typeof window !== "undefined")
        window.onresize = () => {
          if (!this.graph || this.graph.get("destroyed")) return;
          if (!container || !container.scrollWidth || !container.scrollHeight)
            return;
          this.graph.changeSize(container.scrollWidth, container.scrollHeight);
        };
      this.initGraphEvents(this.graph);
    },
    initGraphEvents(graph) {
      this.initGraphSingleClickOnNodeEvent(graph);
    },
    initGraphSingleClickOnNodeEvent(graph) {
      graph.on("node:click", (e) => {
        console.log(e);
        // 对象转数组
        let userData = JSON.parse(JSON.stringify(e.item.getModel()));
        for (let key in userData) {
          if (!this.isChinese(key)) {
            delete userData[key];
          }
        }
        this.selectedUserInfo = userData;
        console.log("this.selectedUserInfo", userData);
        this.informationflag = true;
      });
      graph.on("node:dblclick", (e) => {
        this.informationflag = false;
        console.log(e.item, "e.item");
        const param = {
          label: e.item._cfg.model.class + "",
          名称: e.item._cfg.model.id + "",
        };
        const params = {
          limit: this.limit_num1,
        };
        api.knowledge_graph
          .query_relationship(param, { params })
          .response.then((res) => res.data)
          .then((res) => {
            if (res.code == 200) {
              if (!res.data) {
                this.$message.info("暂无该节点信息");
                return;
              }
              const nodes = res.data[0]?.nodes;
              // .map((item) => this.superLongTextHandle(item.label, 60, 12))
              nodes.forEach((item) => {
                item.label = this.superLongTextHandle(item.label, 60, 12);
              });
              console.log(nodes, "nodes");

              const newnodes = {
                nodes: [],
                edges: [],
              };
              newnodes.nodes = uniqBy(this.G6data.nodes.concat(nodes), "id");

              const edges = res.data[0]?.edges;
              console.log("listData=====>", newnodes.nodes);
              // 更换后端key值

              let kayMap = { label: "edgeLabel" };
              const setEmpty = (data, keyMap) => {
                let objs = Object.keys(data).reduce((newData, key) => {
                  let newKey = keyMap[key] || key;
                  newData[newKey] = data[key];
                  return newData;
                }, {});
                return objs;
              };
              let arr = edges.map((item) => {
                return setEmpty(item, kayMap);
              });
              console.log("newedges", arr);
              newnodes.edges = unionWith(this.G6data.edges, arr);
              this.G6data = newnodes;
              graph.off("node:mouseleave");
              graph.data(this.G6data);
              graph.render();
              console.log("newnodes", this.G6data);
            }

            graph.on("node:mouseenter", (e) => {
              graph.addItem(e.item, {
                labelCfg: {
                  style: {
                    fill: "#ea7171",
                  },
                },
              });
              graph.setItemState(e.item, "active", true);
            });
            graph.on("node:mouseleave", (e) => {
              console.log(e, "mouseleave");
              graph.addItem(e.item, {
                labelCfg: {
                  style: {
                    fill: "#fff",
                  },
                },
              });
              graph.setItemState(e.item, "active", false);
            });
          });
      });
      graph.on("edge:mouseenter", (e) => {
        const deNode = e.item._cfg.model.edgeLabel;
        // console.log(deNode);
        graph.setItemState(e.item, "active", true);
        graph.updateItem(e.item, {
          label: deNode,
          labelCfg: {
            style: {
              stroke: "#f1f8f2",
              fill: "#f1f8f2",
            },
          },
        });
      });
      graph.on("edge:mouseleave", (e) => {
        graph.setItemState(e.item, "active", false);
        graph.updateItem(e.item, {
          label: "",
          labelCfg: {
            style: {
              fill: "#555",
            },
          },
        });
      });
      graph.on("node:mouseenter", (e) => {
        graph.setItemState(e.item, "active", true);
        graph.updateItem(e.item, {
          labelCfg: {
            style: {
              fill: "#ea7171",
            },
          },
        });
      });

      graph.on("node:mouseleave", (e) => {
        graph.setItemState(e.item, "active", false);
        console.log(e, "mouseleave");
        graph.updateItem(e.item, {
          labelCfg: {
            style: {
              fill: "#fff",
            },
          },
        });
      });

      graph.on("nodeselectchange", (e) => {
        console.log(e.selectedItems, e.select);
      });
    },
  },
  mounted() {
    this.initGraph();
    let localhistory = localStorage.getItem("labelsList");
    localhistory = JSON.parse(localhistory);
    this.searchRefList = localhistory;
  },
  // 销毁g6
  beforeDestroy() {
    // 判断当前是否存在g6
    if (this.graph) {
      this.graph.destroy();
      this.graph = "";
    }
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped >
/deep/.el-collapse-item__header {
  background-color: transparent !important;
  color: #fff !important;
  font-weight: bold;
  font-family: "Open Sans", HelveticaNeue-Light, "Helvetica Neue Light",
    "Helvetica Neue", Helvetica, Arial, sans-serif;
}
/deep/.el-collapse-item__wrap {
  background-color: transparent !important;
}
.el-icon-plus {
  float: right;
  color: red;
}
.search_box {
  margin-bottom: 20px;
  color: #333;
  background: rgb(49, 51, 59);
}
/* .images {
  margin-left: 16px;
  margin-top: 10px;
  width: 240px;
  height: 120px;
} */
.limit_num {
  color: #fff;
}
.node_num {
  width: 57px;
  margin-bottom: 10px;
}
/deep/.el-input__inner {
  height: 36px !important;
}
.line {
  font-size: 20px;
  line-height: 36px;
}
.hisText {
  color: white;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.style_meta__wrapper___1Njlk {
  display: flex;
  flex-wrap: wrap;
  margin-left: 10px;
}
.style_meta__wrapper___1Njlk1 {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.style_meta__wrapper___1Njlk1 .first_button:first-child {
  margin-left: 10px;
}
.dYlKXO {
  color: rgb(255, 255, 255);
  border-bottom: 1px solid rgb(66, 70, 80);
  font-size: 14px;
  margin-bottom: 10px;
  line-height: 39px;
  position: relative;
  font-weight: bold;
  -webkit-font-smoothing: antialiased;
  text-shadow: rgb(0 0 0 / 40%) 0px 1px 0px;
  font-family: "Open Sans", HelveticaNeue-Light, "Helvetica Neue Light",
    "Helvetica Neue", Helvetica, Arial, sans-serif;
}
/* .cggqcd {
    word-break: break-all;
    cursor: pointer;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: bold;
    font-size: 12px;
    background-color: rgb(145, 149, 160);
    color: rgb(48, 51, 58);
    margin: 4px;
    padding: 3px 7px;
    border-radius: 20px;
} */
#container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.el-container {
  height: 100%;
}
.el-aside {
  padding: 0px 24px;
  background-color: rgb(49, 51, 59);
  color: #333;
  width: 400px !important;
  height: 100%;
}
.el-main {
  color: #333;
}
#listInformation {
  width: 320px;
  height: 500px;
  padding: 5px;
  color: #fff;
  top: 10px;
  right: 20px;
  position: absolute;
  box-shadow: 0 0 1.5em rgb(188 230 236 / 50%) inset;
  background-color: #212a4b;
  border-radius: 5px;
  overflow: hidden;
  /* white-space: nowrap; */
  text-overflow: ellipsis;
  overflow: auto;
}
.pre {
  width: 300px;
  white-space: pre-wrap; /*css-3*/
  white-space: -moz-pre-wrap; /*Mozilla,since1999*/
  white-space: -pre-wrap; /*Opera4-6*/
  white-space: -o-pre-wrap; /*Opera7*/
  word-wrap: break-word; /*InternetExplorer5.5+*/
  font-family: "Microsoft Yahei", "微软雅黑", "Gill Sans", "Gill Sans MT",
    Calibri, "Trebuchet MS", sans-serif;
  line-height: 22px;
  /* letter-spacing: 2px; */
  margin-left: 8px;
  margin-bottom: 8px;
  margin-right: 5px;
  font-size: 14px;
  text-overflow: ellipsis;
  overflow-y: auto;
  /* pointer-events: none !important; */
}
</style>